import apiClient from '../appConfig/interceptor';
import { endpoints } from '../utils/constants';

const getTargetsList=(selectedProduct:string)=>apiClient.get(`${endpoints.pathPrefix}${selectedProduct}/performance/target`);
const UpdateTarget=(selectedProduct:string,data: any, metric: string)=>apiClient.put(`${endpoints.pathPrefix}${selectedProduct}/performance/target/${metric}`, data);
const DeleteTarget=(selectedProduct:string,data: any, metric: string)=>apiClient.delete(`${endpoints.pathPrefix}${selectedProduct}/performance/target/${metric}`, data);

const targetConfig = {
    getTargetsList,
    UpdateTarget,
    DeleteTarget,
};
export default targetConfig;